<div class="flip-container">
    <div class="flipper" [@flipAnimation]="isFlipped ? 'back' : 'front'">

        <!-- Front Side (Box) -->
        <div class="box front">
            <h3 mat-dialog-title>{{ data.title }}</h3>
            <div mat-dialog-content class="content">
                <span [innerHTML]="data.subTitle"></span>
                <div class="imgWrapper">
                    <img src="assets/images/dailog-box/success.jpg" alt="">
                </div>
                <span class="description" [innerHTML]="data.description"></span>
            </div>
            <div mat-dialog-actions>
                <button mat-raised-button class="Cancel" (click)="skip()">
                    Skip
                </button>
                <button mat-raised-button class="Cancel" (click)="newRequest()">
                    New Request
                </button>
                <button mat-raised-button class="Save"
                        (click)="mapRequest()">
                    Map Request
                </button>
            </div>
        </div>

        <!-- Back Side (Box1) -->
        <div class="box1 back">
            <h3 mat-dialog-title>{{ data.title }}</h3>
            <div mat-dialog-content class="content">
                <p>Back Side Content</p>
            </div>
            <div mat-dialog-actions>
                <button mat-raised-button class="Cancel" (click)="skip()">
                    Skip
                </button>
                <button mat-raised-button class="Cancel" (click)="newRequest()">
                    New Request
                </button>
                <button mat-raised-button class="Save"
                        (click)="mapDO()">
                    Map DO
                </button>
            </div>
        </div>

    </div>
</div>
<div class="bg" [class.set]="set"></div>

